import { useEffect, useState } from "react";

const navLinks = [
  { label: "焦点速览", href: "#spotlight" },
  { label: "深度解读", href: "#deep" },
  { label: "复盘拆解", href: "#timeline" },
  { label: "细节分析", href: "#insights" },
  { label: "观点碰撞", href: "#opinions" },
  { label: "热议榜", href: "#trending" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200/80"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="h-16 md:h-[68px] flex items-center justify-between gap-4">
          <a href="#top" className="flex items-center gap-2.5 shrink-0 cursor-pointer">
            <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
              <i className="ri-eye-2-line text-lg" />
            </span>
            <span className="flex flex-col leading-none">
              <span
                className={`font-heading text-lg font-bold tracking-wide ${
                  scrolled ? "text-foreground-950" : "text-background-50"
                }`}
              >
                黑料看点
              </span>
              <span
                className={`text-[10px] tracking-[0.2em] ${
                  scrolled ? "text-foreground-400" : "text-background-200"
                }`}
              >
                DEEP READ
              </span>
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-7">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className={`text-sm whitespace-nowrap transition-colors cursor-pointer ${
                  scrolled
                    ? "text-foreground-600 hover:text-primary-600"
                    : "text-background-100 hover:text-background-50"
                }`}
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2 md:gap-3">
            <button
              type="button"
              aria-label="搜索"
              className={`hidden sm:flex w-9 h-9 rounded-md items-center justify-center transition-colors cursor-pointer ${
                scrolled
                  ? "text-foreground-600 hover:bg-background-100"
                  : "text-background-50 hover:bg-background-50/15"
              }`}
            >
              <i className="ri-search-line text-lg" />
            </button>
            <a
              href="#download"
              className="whitespace-nowrap rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium px-4 py-2 transition-colors cursor-pointer"
            >
              下载 App
            </a>
            <button
              type="button"
              aria-label="菜单"
              onClick={() => setMenuOpen((v) => !v)}
              className={`lg:hidden w-9 h-9 rounded-md flex items-center justify-center transition-colors cursor-pointer ${
                scrolled
                  ? "text-foreground-800 hover:bg-background-100"
                  : "text-background-50 hover:bg-background-50/15"
              }`}
            >
              <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="lg:hidden bg-background-50 border-t border-background-200/80">
          <nav className="px-4 py-3 flex flex-col">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="py-3 text-sm text-foreground-700 border-b border-background-100 last:border-0 cursor-pointer hover:text-primary-600"
              >
                {link.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}